import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const AccessGroupsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "AccessGroupsPage" */ "@circle-react/components/SettingsApp/AccessGroups"
    ),
);

export const AccessGroupsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <AccessGroupsComponent />
  </Suspense>
);
